// test1065
(1065 && 0);
